/* CD Cart drawer: keeps the theme's <cart-drawer> element (open/close, overlay, Escape, header cart icon,
   product form) but re-renders it from the cd-cart-drawer section, and handles Remove and Upgrade.
   Upgrade swaps the line to the next option in a single cart update: old line to 0, new option added. */
(function () {
  var SECTION = 'cd-cart-drawer';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer.cd-cart'); }

  function patch(el) {
    if (!el || el.dataset.cdPatched) return;
    el.dataset.cdPatched = '1';
    /* The product form asks the drawer which sections to render with the add-to-cart call */
    el.getSectionsToRender = function () {
      return [{ id: SECTION, selector: '#CdCart' }, { id: 'cart-icon-bubble' }];
    };
    el.addEventListener('click', onClick);
  }

  function replace(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections[SECTION]) {
      var fresh = parser.parseFromString(sections[SECTION], 'text/html').querySelector('#CdCart');
      var current = document.getElementById('CdCart');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && html) bubble.innerHTML = html.innerHTML;
    }
  }

  function post(path, body) {
    body.sections = [SECTION, 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  function run(request) {
    var content = document.getElementById('CdCart');
    if (content) content.classList.add('is-busy');
    return request
      .then(function (cart) {
        replace(cart.sections);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SECTION, cartData: cart });
        }
      })
      .catch(function (err) { console.error('[cd-cart]', err); })
      .finally(function () {
        var c = document.getElementById('CdCart');
        if (c) c.classList.remove('is-busy');
      });
  }

  function onClick(e) {
    var remove = e.target.closest('[data-cd-remove]');
    if (remove) {
      e.preventDefault();
      run(post('cart/change.js', { id: remove.dataset.key, quantity: 0 }));
      return;
    }
    var upgrade = e.target.closest('[data-cd-upgrade]');
    if (upgrade) {
      e.preventDefault();
      var updates = {};
      updates[upgrade.dataset.key] = 0;
      updates[upgrade.dataset.to] = parseInt(upgrade.dataset.qty, 10) || 1;
      run(post('cart/update.js', { updates: updates }));
    }
  }

  function boot() {
    customElements.whenDefined('cart-drawer').then(function () { patch(drawer()); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor: re-patch after the section re-renders, open the drawer while it is selected */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === SECTION) boot();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail && e.detail.sectionId === SECTION) {
      customElements.whenDefined('cart-drawer').then(function () { var d = drawer(); if (d) d.open(); });
    }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail && e.detail.sectionId === SECTION) { var d = drawer(); if (d) d.close(); }
  });
})();
